import type { PlayCurrency } from '../api/preferences';

/** Suggested payment region for a play currency (not a hard country identity). */
export const CURRENCY_TO_REGION: Record<PlayCurrency, string> = {
  AZN: 'AZ',
  RUB: 'RU',
  USD: 'US',
  EUR: 'EU',
};

export const REGION_TO_CURRENCY: Record<string, PlayCurrency> = {
  AZ: 'AZN',
  RU: 'RUB',
  US: 'USD',
  EU: 'EUR',
};

const REGION_MANUAL_KEY = 'vbbplay.payment_region_manual';

export function hasManualPaymentRegion(): boolean {
  try {
    return localStorage.getItem(REGION_MANUAL_KEY) === '1';
  } catch {
    return false;
  }
}

export function markPaymentRegionManual(): void {
  try {
    localStorage.setItem(REGION_MANUAL_KEY, '1');
  } catch {
    // ignore
  }
}

export function suggestedRegionForCurrency(currency: string | null | undefined): string | null {
  const code = String(currency || '').toUpperCase() as PlayCurrency;
  return CURRENCY_TO_REGION[code] || null;
}
